import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";

import { RootState } from "store/reducers/rootReducer";

import IZone from "../../../interfaces/IZone";
import { ISearchableSelectOption } from "../../material/select/interfaces/ISearchableSelectProps";
import Select from "../../material/select/searchableSelect";

import ISelectCleaningObjectProps, { ISelectCleaningObjectStateProps } from "./interfaces/ISelectCleaningObjectProps";

class SelectCleaningObject extends Component<ISelectCleaningObjectProps> {
  private getItemAsSelectOptionFn(cleaningObject: IZone): ISearchableSelectOption {
    return {
      id: cleaningObject.id,
      label: cleaningObject.name,
    };
  }

  public render(): ReactNode {
    return (
      <>
        <Select
          id={this.props.id}
          name={this.props.name}
          value={this.props.value}
          onChange={this.props.onChange}
          options={this.props.cleaningObjects ?? []}
          getItemAsSelectOptionFn={this.getItemAsSelectOptionFn}
        />
      </>
    );
  }
}

const mapStateToProps = (state: RootState): ISelectCleaningObjectStateProps => {
  return {
    cleaningObjects: state.cleaningObjectState.cleaningObjects ?? [],
  };
};

export default connect(mapStateToProps)(SelectCleaningObject);
